export default class GetGradoPromocionById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(id) {
    try {
      const result = await this.#repository.getGradoPromocionById(id)
      return result
    } catch (error) {
      console.error('Error al obtener el grado de promoción:', error)
      throw error
    }
  }
}
